import React, { useEffect, useState, useCallback } from 'react';
import { ServiceGridContainer, LoadingContainer, Container, SubTitle, ContainerLoadingMoreMovies } from './styles.js';
import Load from '../../../components/load/index.js';
import Movie from '../../../components/movie/index.js';
import { AppFirebase } from '../../../config/firebase.js';
import { getFirestore, query, collection, where, limit, getDocs, startAfter } from 'firebase/firestore';
import { Swiper, SwiperSlide } from "swiper/react";
import BandeiraBrasil from "../../../components/images/bandeira-brasil.png";
import UseAnimations from 'react-useanimations';
import loading from 'react-useanimations/lib/loading';
import { useParams } from 'react-router-dom';

// Função para embaralhar um array
const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};

const Movies = ({ user, setMovies }) => {
    const [loadingMovies, setLoadingMovies] = useState(false);
    const [sectionsData, setSectionsData] = useState([]);
    const [lastVisibleDocs, setLastVisibleDocs] = useState({});
    const [hasMoreMovies, setHasMoreMovies] = useState({});

    const { mediaType } = useParams();
    
    // Função de busca para obter filmes com paginação
    const fetchMoviesForSection = async (section, lastVisible = null) => {
        const database = getFirestore(AppFirebase);
        const allMovies = [];
    
        try {
            // Configuração da consulta com startAfter para carregar mais documentos
            let moviesQuery = query(
                collection(database, "watch"),
                where("media_type", "==", mediaType),
                limit(6)
            );
    
            if (lastVisible) {
                moviesQuery = query(moviesQuery, startAfter(lastVisible));
            }
    
            const querySnapshot = await getDocs(moviesQuery);
            const lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1]; // Define o último documento
    
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                allMovies.push({ id: doc.id, ...data });
            });
    
            const shuffledMovies = shuffleArray(allMovies).slice(0, 6);
            return { title: section.title, movies: shuffledMovies, lastVisible: lastDoc }; // Retorna lastVisible
    
        } catch (error) {
            console.error("Erro ao buscar filmes:", error);
            return { title: section.title, movies: [], lastVisible: null };
        }
    };
    
    const sectionsMovies = [
        { title: 'Filmes de Jogos Mortais', tags: [40], ignoreTags: [] },
        //{ title: 'Filmes Futurísticos', tags: [15], ignoreTags: [] },
        { title: 'Teen', tags: [25], ignoreTags: [] },
        { title: 'Baseado em Fatos Reais', tags: [5], ignoreTags: [] },
        { title: 'Brasileiros', tags: [6], ignoreTags: [] },
        { title: 'Documentários', tags: [10], ignoreTags: [] },
        //{ title: 'Filmes de Piratas', tags: [34], ignoreTags: [] },
    ];

    const sectionsTv = [
        { title: 'Drama Médico', tags: [28], ignoreTags: [] },
        { title: 'Brasileiros', tags: [6], ignoreTags: [] },
        { title: 'Documentários', tags: [10], ignoreTags: [] },
        { title: 'Séries Teen', tags: [25], ignoreTags: [] },
        //{ title: 'Zumbis', tags: [27], ignoreTags: [] },
        //{ title: 'Séries de Investigação Policial', tags: [37], ignoreTags: [] },
    ];

    if (mediaType == 'tv') {
        var sections = sectionsTv;
    } else {
        sections = sectionsMovies;
    }

    const loadSections = useCallback(async () => {
        setLoadingMovies(true);
        const allSectionsData = '' //await Promise.all(sections.map(section => fetchMoviesForSection(section)));
        
        const updatedLastVisibleDocs = {};
        const updatedHasMoreMovies = {};

        allSectionsData.forEach((data, index) => {
            updatedLastVisibleDocs[sections[index].title] = data.lastVisible;
            updatedHasMoreMovies[sections[index].title] = data.movies.length > 0; // Verifica se há filmes
        });

        setLastVisibleDocs(updatedLastVisibleDocs);
        setHasMoreMovies(updatedHasMoreMovies);
        setSectionsData(allSectionsData);
        setLoadingMovies(false);
    }, []);

    const loadMoreMovies = async (section) => {


        if (!hasMoreMovies[section.title]) return; // Não carrega mais se não houver mais filmes

        const lastVisible = lastVisibleDocs[section.title];
        const newSectionData = await fetchMoviesForSection(section, lastVisible);

        // Se não retornar novos filmes, marca hasMoreMovies como false para essa seção
        setHasMoreMovies(prev => ({
            ...prev,
            [section.title]: newSectionData.movies.length > 0
        }));

        setSectionsData(prevSectionsData =>
            prevSectionsData.map(sec => sec.title === section.title 
                ? { ...sec, movies: [...sec.movies, ...newSectionData.movies] } 
                : sec
            )
        );

        setLastVisibleDocs(prev => ({
            ...prev,
            [section.title]: newSectionData.lastVisible
        }));

    };

    useEffect(() => {
        loadSections();
    }, []);

    return (
        <Container>
            {sectionsData.map((section, index) => {
                if (section.movies.length > 0) {

                    return (
                        <div key={index}>
                            <SubTitle>
                                {section.title}
                                {section?.title === "Brasileiros" && <img src={BandeiraBrasil} alt="Bandeira do Brasil" />}
                            </SubTitle>
                            <Swiper
                                slidesPerView={"auto"}
                                spaceBetween={0}
                                freeMode={false}
                                horizontal={true}
                                onReachEnd={() => loadMoreMovies(sections[index])} // Chama ao atingir o final da rolagem
                                pagination={{ clickable: true }}
                                className="div-movies"
                            >
                                {section.movies.length > 0 ? (
                                    section.movies.map((movie, idx) => (
                                        <SwiperSlide key={movie.id || idx}>
                                            <ServiceGridContainer>
                                                <Movie movie={movie} index={idx} />
                                            </ServiceGridContainer>
                                        </SwiperSlide>
                                    ))
                                ) : (
                                    <p>Nenhum filme encontrado para esta seção.</p>
                                )}
                            </Swiper>
                        </div>
                    )
                } else {
                    return
                }
            })}

            {loadingMovies && (
                <LoadingContainer>
                    <Load />
                </LoadingContainer>
            )}
        </Container>
    );
};

export default Movies;